import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { DeleteCsvExcelAccountsRequestModel, DeleteCsvExcelAccountsResponseModel } from "@/features/accounts/csv-excel/services/delete-accounts-model";

export class DeleteCsvExcelAccountsApi {
  /**
   * CsvExcel削除API
   */
  public deleteCsvExcelAccounts = async (
    param: DeleteCsvExcelAccountsRequestModel
  ): Promise<DeleteCsvExcelAccountsResponseModel> => {
    const path = `/api/csvexcelaccounts`;
    const res = await ApiClient.instance.delete<DeleteCsvExcelAccountsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
